import React, { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Sun, Moon } from "lucide-react"; // 使用 lucide-react 圖標庫
import logo from "./assets/logo.png";
import logoWhite from "./assets/white-logo.png";

function Login() {
  const [darkMode, setDarkMode] = useState(
    JSON.parse(localStorage.getItem("darkMode")) ?? true
  );
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const navigate = useNavigate();

  const handleDarkModeToggle = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem("darkMode", JSON.stringify(newDarkMode));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://api.mcvanuatu.com/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ account, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token);
        setShowNotification(true); // 顯示登入成功通知
        setTimeout(() => {
          navigate("/dashboard"); // 2秒後跳轉到儀表板
        }, 2000);
      } else {
        const errorData = await response.json();
        setError(errorData.message || "登入失敗 Login Failed");
      }
    } catch (err) {
      setError("無法連接到伺服器 Unable to connect to the server");
    }
  };

  return (
<div
  className={`flex items-start sm:items-center justify-center min-h-screen 
    ${darkMode 
      ? "sm:bg-[#121212] bg-[#1E1E1E] text-[#FFFFFF]" 
      : "sm:bg-[#FFFFFF] bg-[#F5F5F5] text-[#121212]"
    }`}
>
      {/* 模式切換按鈕 */}
      <button
        onClick={handleDarkModeToggle}
        className="absolute top-4 right-4 p-2 rounded-full bg-transparent hover:bg-opacity-25 transition"
      >
        {darkMode ? (
          <Sun className="text-[#FFFFFF] w-6 h-6 hover:text-[#2C2C2C]" />
        ) : (
          <Moon className="text-[#121212] w-6 h-6 hover:text-[#2C2C2C]" />

        )}
      </button>

      {/* 登入卡片 */}
  <motion.div
    className={`w-full max-w-md p-8 rounded-lg mt-12 sm:mt-0 
      ${darkMode 
        ? "bg-[#1E1E1E]" 
        : "bg-[#F5F5F5]"
      }
      ${// 只在非手機版時添加陰影
        "sm:shadow-lg"
      }`}
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
  >
        <motion.div
          className="flex justify-center mb-6"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{
            type: "spring",
            stiffness: 150,
            damping: 10,
          }}
        >
          <img
            src={darkMode ? logoWhite : logo}
            alt="Logo"
            className="w-32 h-32 mb-4"
          />
        </motion.div>

        <h2
          className={`text-2xl font-bold text-center ${
            darkMode ? "text-[#FFFFFF]" : "text-[#121212]"
          }`}
        >
          查詢系統 Query System
        </h2>

        <form onSubmit={handleLogin} className="mt-6">
          {error && (
            <motion.p
              className="text-red-500 text-sm mb-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              {error}
            </motion.p>
          )}

          <div>
            <label
              className={`block text-sm font-medium ${
                darkMode ? "text-[#FFFFFF]" : "text-[#121212]"
              }`}
            >
              帳戶 Account
            </label>
            <input
              type="text"
              required
              value={account}
              onChange={(e) => setAccount(e.target.value)}
              className={`w-full mt-2 p-2 border rounded-md focus:outline-none ${
                darkMode
                  ? "bg-[#121212] border-[#404040] text-[#FFFFFF] focus:ring-[#2C2C2C]"
                  : "bg-[#F5F5F5] border-[#E0E0E0] text-[#121212] focus:ring-[#404040]"
              }`}
            />
          </div>

          <div className="mt-4">
            <label
              className={`block text-sm font-medium ${
                darkMode ? "text-[#FFFFFF]" : "text-[#121212]"
              }`}
            >
              密碼 Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`w-full mt-2 p-2 border rounded-md focus:outline-none ${
                darkMode
                  ? "bg-[#121212] border-[#404040] text-[#FFFFFF] focus:ring-[#2C2C2C]"
                  : "bg-[#F5F5F5] border-[#E0E0E0] text-[#121212] focus:ring-[#404040]"
              }`}
            />
          </div>

          <motion.button
            type="submit"
            className={`w-full mt-6 py-2 px-4 font-semibold rounded-md ${
              darkMode
                ? "bg-[#121212] text-[#FFFFFF] hover:bg-[#2C2C2C]"
                : "bg-[#404040] text-white hover:bg-[#1E1E1E]"
            }`}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            登入 Login
          </motion.button>
        </form>
      </motion.div>

      {/* 登入成功通知 */}
      {showNotification && (
        <motion.div
          className={`fixed inset-0 flex items-center justify-center ${
            darkMode ? "bg-black bg-opacity-70" : "bg-[#F5F5F5] bg-opacity-70"
          }`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div
            className={`p-6 rounded-lg shadow-lg flex items-center space-x-4 ${
              darkMode ? "bg-[#1E1E1E]" : "bg-[#F5F5F5]"
            }`}
          >
            {/* 載入動畫 */}
            <motion.div
              className={`w-6 h-6 border-4 rounded-full animate-spin ${
                darkMode ? "border-[#FFFFFF] border-t-[#1E1E1E]" : "border-[#404040] border-t-[#F5F5F5]"
              }`}
            ></motion.div>
            {/* 提示文字 */}
            <p
              className={`text-lg font-semibold ${
                darkMode ? "text-[#FFFFFF]" : "text-[#121212]"
              }`}
            >
              登入成功！正在跳轉...
            </p>
          </div>
        </motion.div>
      )}
    </div>
  );
}

export default Login;